<template>
  <div />
</template>

<script>
export default {
  name: 'ExternalLogin',
  data() {
    return {
      code: this.$route.params.code,
    };
  },
  mounted() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.getUserBySession();
    },
    async getUserBySession() {
      try {
        const { code, user } = await brain.utils.ajaxMicroservice({
          method: 'GET',
          uri: `/v1/session/app/${brain.company.json.id}/user/session`,
          microservice: 'auth',
          headers: {
            code: this.code,
          },
        });

        await this.loadFromLogin({ code, user });

        this.redirect({ user });
      } catch (err) {
        console.log('err getUserBySession :>> ', err);

        throw err;
      }
    },
    async loadFromLogin({ code, user }) {
      await brain.user.loadFromLogin(user, code, null, false);

      this.$cookies.set('code', code);
      localStorage.setItem('code', btoa(code));

      brain.openChat();
    },
    redirect({ user }) {
      if (user.pendingTerms && Object.keys(user.pendingTerms).length)
        return this.redirectToTermsRoute(user);

      return brain.sendToAppRoute(true);
    },
    redirectToTermsRoute({ pendingTerms }) {
      const url = brain.user.getTermUrl({ pendingTerms });

      brain.redirectToRoute(url);
    },
  },
};
</script>
